function getPid(){
    let dom = document.querySelector('#isPid');
    if(dom?.value && dom?.value != ""){
        return parseInt(dom.value);
    }

    return null;
}

function matchPid(...pids){
    let pid = getPid();

    if(pids.indexOf(pid) != -1){
        return pid;
    }

    return null;
}
module.exports = { getPid, matchPid };